import { objectSelector } from 'theme/utils';

import { request } from '../axios/request';

import {
  FETCH_PACKAGE_STATUS_LIST_PENDING,
  FETCH_PACKAGE_STATUS_LIST_REJECTED,
  FETCH_PACKAGE_STATUS_LIST_FULFILLED,
} from '../constants/packageStatuses';
import { activateStaff } from './staffs';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_PACKAGE_STATUS_LIST_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_PACKAGE_STATUS_LIST_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: FETCH_PACKAGE_STATUS_LIST_REJECTED,
  error,
});

export const fetchPackageStatuses = (staffId) => (dispatch) => {
  const responseLanguage = objectSelector($A, 'RESPONSE_LANGUAGE', 'en-us');
  dispatch(pending());

  request({
    method: 'get',
    url: OMS.OMS.PACKAGE_STATUS_LIST,
    headers: {
      'accept-language': responseLanguage,
    },
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
      dispatch(activateStaff(staffId));
    })
    .catch((error) => {
      dispatch(rejected(error));
      dispatch(activateStaff(staffId));
    });
};



// WEBPACK FOOTER //
// ./src/actions/packageStatuses.js